import React from "react";
import { useIncidents } from "./IncidentEntryContext";
import {
  Box,
  CircularProgress,
  Typography,
  Button,
  TableCell,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { Link, Navigate } from "react-router-dom";

const IncidentsList = () => {
  const {
    incidents,
    setSelectedIncident,
    authenticationChecked,
    setIncident,
    fetchNewIncident,
  } = useIncidents();

  const viewEditLinkIcon = (item) => {
    return (
      <Link
        className="hyper-links"
        onClick={(e) => {
          e.preventDefault();
          setSelectedIncident(item);
        }}
      >
        {item.id}
      </Link>
    );
  };

  const dataGridColumns = [
    {
      field: "id",
      headerName: "ID",
      minWidth: 200,
      filterable: true,
      sortable: true,
      renderCell: (params) => viewEditLinkIcon(params.row),
    },
    {
      field: "location",
      headerName: "Location",
      minWidth: 500,
      filterable: true,
      sortable: true,
      flex: 0.2,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 500,
      filterable: true,
      sortable: true,
      flex: 0.2,
    },
    {
      field: "externalId",
      headerName: "External ID",
      minWidth: 200,
      filterable: true,
      sortable: true,
      flex: 0.2,
    },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        <div style={{ flex: 1 }} />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    );
  }

  if (incidents !== null && incidents.length > 0) {
    return (
      <>
        <Typography variant="h5" sx={{ mb: 2, textAlign: "center", mt: 2 }}>
          {" "}
          Manage Incidents List{" "}
        </Typography>
        <TableCell>
          <Button variant="contained" onClick={() => fetchNewIncident()}>
            {" "}
            Create New Incident{" "}
          </Button>
        </TableCell>
        <DataGrid
          rows={incidents}
          columns={dataGridColumns}
          disableSelectionOnClick
          components={{
            Toolbar: CustomToolbar,
          }}
          sx={{
            "& .MuiDataGrid-columnHeaders": {
              fontSize: "1rem",
              fontWeight: "bold",
              display: "flex",
            },
          }}
        />
      </>
    );
  } else if (incidents !== null && incidents.length === 0) {
    return (
      <Box sx={{ textAlign: "center", mt: 4, mb: 4 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Manage Incidents List
        </Typography>
        <Typography variant="h6" sx={{ mb: 3, color: "text.secondary" }}>
          No incidents available
        </Typography>
        <Button variant="contained" onClick={() => fetchNewIncident()}>
          {" "}
          Create New Incident{" "}
        </Button>
      </Box>
    );
  } else {
    if (authenticationChecked === "Success") {
      return (
        <Box sx={{ width: "100%", textAlign: "center" }}>
          <CircularProgress />
        </Box>
      );
    }
    if (authenticationChecked === "UNAUTHORIZED") {
      const wasAdminLoggedIn = sessionStorage.getItem("isAdmin") === "true";
      const isUserLoggedIn = sessionStorage.getItem("isUser") === "true";
      if (isUserLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            You are not authorized to view this page.
          </Typography>
        );
      else if (wasAdminLoggedIn)
        return (
          <Typography sx={{ textAlign: "center", m: 2 }} variant="h6">
            Session expired.{" "}
            <Link to="/About/AdminLogin" className="hyper-links">
              <b>Click here to log back in</b>
            </Link>
          </Typography>
        );
      else return <Navigate to="/About/AdminLogin" replace />;
    }
    if (authenticationChecked === "FORBIDDEN")
      return <Navigate to="/About/AdminLogin" replace />;
  }
};

export default IncidentsList;
